// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-l_gM","advertDetailContacts__header":"c-l_gN"};